module.exports = __webpack_public_path__ + "img/seejc_vizual.d842de6e.jpg";